import { TransferOrdersService } from 'application/services/transfer-orders'
import { api } from 'infra/adapters/http-client-adapter'

export const handleTransferOrders = new TransferOrdersService(api)
